import { boot } from 'quasar/wrappers'
import MarqueeText from 'vue-marquee-text-component'

export default boot(async ({ app }) => {
	app.component('marquee-text', MarqueeText)
})
